import React from 'react';
import queryString from 'query-string';
import './Dropdown.css';

import FaGlobe from 'react-icons/lib/fa/globe';
import FaDown from 'react-icons/lib/fa/caret-down';
import FaUp from 'react-icons/lib/fa/caret-up';

export default class Dropdown extends React.Component {

	state = {
		open: false
	};

	handleChange = value => {
		const langParam = queryString.stringify({ lang: value });
		window.location.search = langParam;
	};

	toggleOpen = () => {
		this.setState({
			open: !this.state.open
		});
	};

	getSelectedLang = () => {
		const selectedOption = this.props.options.find( option => option.value === this.props.lang ) || {};
		return selectedOption.label || '';
	};

	render () {
		const { open } = this.state;
		const options = this.props.options.map( option => (
			<li
				key={option.value}
				onClick={this.handleChange.bind(this, option.value)}
			>
				{option.label}
			</li>
		));
		return (
			<div className={`dropdown ${open ? 'open' : ''}`} onClick={this.toggleOpen}>
				<FaGlobe />
				<span className="dropdown-value">{this.getSelectedLang()}</span>
				{open ? <FaUp /> : <FaDown />}
				{open &&
					<ul className="dropdown-menu">
						{options}
					</ul>
				}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/Dropdown/Dropdown.js